module.exports = __webpack_public_path__ + "static/media/Inter-Regular.14d1275c.woff";